import Vue from 'vue';
import { RRWEB_RECORD_STATE, MAX_RECORD_LIMIT } from './const';
import Countdown from './countdown';

function createButton(text, color, style) {
  const button = document.createElement('button');
  const buttonStyles = {
    color: 'white',
    backgroundColor: color,
    border: 'none',
    padding: '5px 10px',
    marginRight: '10px',
    ...style,
  };
  Object.assign(button.style, buttonStyles);
  button.innerHTML = text;
  return button;
}

const containerStyles = {
  position: 'fixed',
  top: '20px',
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: '9999',
  display: 'flex',
  alignItems: 'center',
};

const countdownStyles = {
  marginRight: '10px',
  color: '#ED7266',
};

export function initRecordUI(monitor, recorder) {
  const countdown = new Countdown({
    duration: MAX_RECORD_LIMIT,
    onTick,
    onComplete,
  });

  // 容器
  const container = document.createElement('div');
  Object.assign(container.style, containerStyles);

  // 按钮
  const recordButton = createButton('开始录制', '#ED7266');
  const submitButton = createButton('确认提交', '#14BB8C', {
    display: 'none',
  });

  function updateButtons() {
    const btnText = {
      [RRWEB_RECORD_STATE.init]: '开始录制',
      [RRWEB_RECORD_STATE.recording]: '停止录制',
      [RRWEB_RECORD_STATE.done]: '重新录制',
    };
    recordButton.innerHTML = btnText[monitor.recordState];
    submitButton.style.display =
      monitor.recordState === RRWEB_RECORD_STATE.done ? 'inline-block' : 'none';

    if (monitor.loading) {
      submitButton.innerHTML = '数据上传中, 请稍侯...';
      recordButton.style.display = 'none';
    } else {
      submitButton.innerHTML = '确认提交';
      recordButton.style.display = 'inline-block';
    }
  }

  function handleRecordButtonClick() {
    if (monitor.loading) return;

    if (monitor.recordState === RRWEB_RECORD_STATE.recording) {
      recorder.stop();
      countdown.stop();
      monitor.recordState = RRWEB_RECORD_STATE.done;
    } else {
      countdown.start();
      recorder.start();
      monitor.recordState = RRWEB_RECORD_STATE.recording;
    }
    updateButtons();
  }

  function handleSubmitButtonClick() {
    const events = recorder.getAllData();
    if (!events.length || monitor.loading) return;

    monitor.batchSubmitData().then((res) => {
      updateButtons();
      Vue.prototype.$message({
        type: 'success',
        message: '上报成功',
        offset: 60,
      });
    });
    updateButtons();
  }

  // 倒计时
  const countdownEl = document.createElement('div');
  Object.assign(countdownEl.style, countdownStyles);
  function onTick(time) {
    countdownEl.innerHTML = time;
  }
  function onComplete() {
    Vue.prototype.$message({
      type: 'warning',
      message: '超过最大录制时间，已自动停止录制，请提交录制内容',
      offset: 60,
    });
    handleRecordButtonClick();
  }

  recordButton.addEventListener('click', handleRecordButtonClick);
  submitButton.addEventListener('click', handleSubmitButtonClick);

  container.appendChild(countdownEl);
  container.appendChild(recordButton);
  container.appendChild(submitButton);
  document.body.appendChild(container);
}
